var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustwallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_182_2612)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1397,
    cy: 20,
    rx: 20.1397,
    ry: 20,
    fill: "url(#paint0_linear_182_2612)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1953 12.1451L19.8868 8.99512V30.8014C12.9642 27.8936 10.1953 22.3209 10.1953 19.1716V12.1451Z",
    fill: "#0500FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5782 12.1451L19.8867 8.99512V30.8014C26.8093 27.8936 29.5782 22.3209 29.5782 19.1716V12.1451Z",
    fill: "url(#paint1_linear_182_2612)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_182_2612",
    x: -20,
    y: -20,
    width: 80.2812,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_182_2612"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_182_2612",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_182_2612",
    x1: 0,
    y1: 0,
    x2: 29.3546,
    y2: 46.8457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_182_2612",
    x1: 27.0038,
    y1: 7.4681,
    x2: 19.6828,
    y2: 30.5035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#0000FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#48FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0038FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0500FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustwallet);
export default __webpack_public_path__ + "static/media/trustwallet.2df6ee603bd077f4e9c81a8ce8bb6b71.svg";
export { ForwardRef as ReactComponent };